// extracted by mini-css-extract-plugin
export default {"tab":"Tabs_tab__0j3uA","activeTab":"Tabs_activeTab__AQCjb","activeTab__dark":"Tabs_activeTab__dark__pPHFD"};